module.exports = __webpack_public_path__ + "img/stock5.a28d9278.png";